export default __webpack_public_path__ + "static/media/little-boy-playing-with-construction-equipment-white (1).94438362.jpg";